import { Skeleton } from '@ballerine/ui';
import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { QaleLogo } from '@/common/components/atoms/icons';
import { useRedirectToRootUrl } from '@/common/hooks/useRedirectToRootUrl/useRedirectToRootUrl';
import { ctw } from '@/common/utils/ctw/ctw';
import { useCustomerQuery } from '@/domains/customer/hooks/queries/useCustomerQuery/useCustomerQuery';

const LogoContent = () => {
  const { isLoading } = useCustomerQuery();

  if (isLoading) {
    return <Skeleton className="h-24 w-full" />;
  }

  // Always show QYC logo with text (white-labeled)
  return (
    <div className="flex items-center gap-3 px-2 py-2">
      <div className="flex-shrink-0">
        <QaleLogo className="h-12 w-12" style={{ height: '48px', width: '48px' }} />
      </div>
      <span className="text-3xl font-bold tracking-tight" style={{ 
        background: 'linear-gradient(135deg, #7315E6 0%, #94BEF0 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
        QYC
      </span>
    </div>
  );
};

export const NavLogo: FunctionComponent<{ className?: string }> = ({ className }) => {
  const urlToRoot = useRedirectToRootUrl();

  return (
    <Link to={urlToRoot} className={ctw('w-full cursor-pointer pr-12', className)}>
      <LogoContent />
    </Link>
  );
};
